import NsfwWarning from "./NsfwWarning";

export default NsfwWarning;
